import http from "../services/httpService";

export async function getFlatPage(slug) {
    const resp = await http.get(`/flat_pages/${slug}/`)
    return resp.data
}
